const { useRef, useEffect } = require('react');

const usePrevious = (value) => {
    const ref = useRef();
    // Store current value in ref
    useEffect(() => {
        ref.current = value;
    }, [value]); // Only re-run if value changes

    return ref.current;
};

export default usePrevious;
